'use client';
import { CatHeading } from 'blocks-nextjs/blocks-react/components/Heading';
import { getProductName } from '@cat-ecom/common/utils/stringUtils';
import { getFamilyName } from 'services/equipment/utils';

export const SelectedEquipmentDrawerInfo = ({
  assetId,
  serialNumber,
  model,
  productFamily,
  name,
  PCCLucidHeadlessMEQDrawerFlag
}: {
  assetId?: string;
  serialNumber?: string;
  model?: string;
  productFamily?: string;
  name?: string;
  PCCLucidHeadlessMEQDrawerFlag?: boolean;
}) => {

  const equipmentName = PCCLucidHeadlessMEQDrawerFlag ?
    `${model} ${getProductName(getFamilyName(model, name))}` :
    `${model} ${getProductName(productFamily)}`;
  return (
    <>
      {assetId && <CatHeading variant="title">{assetId}</CatHeading>}
      <CatHeading variant={!assetId ? 'title' : 'body-sm'}>
        <span className="u-color--Black">
          {equipmentName}
        </span>
      </CatHeading>
      {serialNumber && (
        <CatHeading variant="body">
          <span className="u-color--Black">{serialNumber}</span>
        </CatHeading>
      )}
    </>
  );
};
